module.exports = __webpack_public_path__ + "static/media/mydetails.edc06ee4.png";